import {FC, ReactNode} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {Box, CircularProgress} from '@mui/material';
import {useAuth} from "../../contexts/AuthContext.tsx";

interface ProtectedRouteProps {
    children: ReactNode;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({children}) => {
    const {firebaseUser, loading} = useAuth();
    const location = useLocation();

    // 로딩 중
    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <CircularProgress/>
            </Box>
        );
    }

    // 로그인되지 않은 경우 로그인 페이지로 리다이렉트
    if (!firebaseUser) {
        return <Navigate to="/login" state={{from: location}} replace/>;
    }

    // 로그인된 경우 children 렌더링
    return <>{children}</>;
};
